import React, { useState, useEffect } from "react";
import { mlmAPI } from "../services/api";

const ReferralCard = () => {
  const [referralData, setReferralData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetchReferralCode();
  }, []);

  const fetchReferralCode = async () => {
    try {
      const data = await mlmAPI.getMyReferralCode();
      setReferralData(data);
    } catch (error) {
      console.error("Failed to fetch referral code:", error);
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  if (loading) {
    return (
      <div className="bg-[var(--bg-card)] rounded-lg p-4 border border-[var(--border-color)]">
        <div className="animate-pulse flex items-center justify-between">
          <div className="h-4 bg-surface-soft rounded w-2/3"></div>
          <div className="h-8 w-8 bg-surface-soft rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[var(--bg-card)] rounded-lg p-4 border border-[var(--border-color)]">
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs text-[var(--text-primary)] opacity-60 mb-1">
            Your Referral Link
          </p>
          <p className="text-xs sm:text-sm text-[var(--text-primary)] font-mono break-all">
            {referralData?.referralLink}
          </p>
        </div>
        <button
          onClick={() => copyToClipboard(referralData?.referralLink)}
          className="flex-shrink-0 p-2 rounded-lg bg-gradient-to-r from-[#22c55e] to-[#16a34a] hover:opacity-80 transition-all duration-200"
          title="Copy referral link"
        >
          {copied ? (
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default ReferralCard;
